import { Button } from "primereact/button";
import { Card } from "primereact/card";
import { useParams } from "react-router-dom";

import React, { useEffect } from "react";
import AdminOnly from "~/components/AdminOnly";
import Notification from "~/components/entities/notification/Notification";
import useShareHolderRegistry from "./useShareHolderRegistry";
import ShareRegistryTable from "../share-registry/ShareRegistryTable";
import AddTransactionModal from "../share-registry/modal/AddTransactionModal";
import CustomeButton from "~/components/Button";

import AuditSidebar from "~/components/audit-sidebar/AuditSidebar";
import API_ROUTES from "~/api-routes";

const ShareholderRegistry = () => {
  const { id } = useParams();

  const {
    shareRegistryData,
    setShareRegistryData,
    modalVisible,
    setModalVisible,
    transaction,
    setTransaction,
    edit,
    setEdit,
    rowIndex,
    setRowIndex,
    loading,
    formatDate,
    fetchShareRegistry,
    updateShareRegistryTransaction,
    addShareRegistryTransaction,
    successMessage,
    setSuccessMessage,
    isBtnLoading,
    onPageChange,
    pageSize,
    page,
    totalRecords,
    isAuditSidebarVisible,
    setAuditSidebarVisible,
  } = useShareHolderRegistry();

  const editTransactionHandler = (data, index) => {
    setEdit(true);
    setModalVisible(true);
    setTransaction(data);
    setRowIndex(index);
  };

  const closeModal = () => {
    setModalVisible(false);
    setEdit(false);
    setTransaction({});
    setRowIndex("");
  };

  useEffect(() => {
    fetchShareRegistry();
  }, []);

  const auditLabels = () => {
    return {
      create: "Share Registered",
      update: "Share Updated",
      delete: "Share Deleted",
    };
  };
  return (
    <Card className="shareholder_registry--card personal-info-card">
      <div className=" mb-5 flex justify-content-between formgrid grid grid-nogutter">
        <div>
          <p className="personal-information-heading">Share Registry</p>
        </div>

        <AdminOnly>
          <div className="flex gap-2 align-items-center">
            <Button
              className="edit-button"
              onClick={() => setAuditSidebarVisible(true)}
            >
              View History
              <span className="pi pi-history mb-1 ml-2" />
            </Button>
            <CustomeButton
              label="Add Share Transaction"
              className="add-transaction-button"
              icon="pi pi-plus"
              iconPos="right"
              variant="contained"
              onClick={() => setModalVisible(true)}
            />
          </div>
        </AdminOnly>
        <Notification
          successMessage={successMessage}
          setSuccessMessage={setSuccessMessage}
        />
      </div>

      <ShareRegistryTable
        shareRegistryData={shareRegistryData}
        setModalVisible={setModalVisible}
        formatDate={formatDate}
        editTransactionHandler={editTransactionHandler}
        loading={loading}
        onPageChange={onPageChange}
        pageSize={pageSize}
        page={page}
        totalRecords={totalRecords}
        isEditing={true}
      />
      {/* Transaction Modal */}
      {modalVisible && (
        <AddTransactionModal
          visible={modalVisible}
          setModalVisible={setModalVisible}
          transaction={transaction}
          setTransaction={setTransaction}
          setShareRegistryData={setShareRegistryData}
          edit={edit}
          setEdit={setEdit}
          rowIndex={rowIndex}
          setRowIndex={setRowIndex}
          closeModal={closeModal}
          isEditing={true}
          updateTransaction={updateShareRegistryTransaction}
          addRegistryTransaction={addShareRegistryTransaction}
          loading={loading}
          isBtnLoading={isBtnLoading}
        />
      )}

      {isAuditSidebarVisible && (
        <AuditSidebar
          heading="Share Registry"
          endpoint={API_ROUTES.FETCH_SHAREHOLDER_REGISTRY_AUDIT}
          id={id}
          objectType="shareholder"
          setSidebarToggle={setAuditSidebarVisible}
          sidebarToggle={isAuditSidebarVisible}
          labels={auditLabels}
        />
      )}
    </Card>
  );
};

export default ShareholderRegistry;
